import styled from 'styled-components';

export const InfoCardContainer = styled.div`
  display: flex;
  font-size: 14px;
  font-style: normal;
  border-radius: 4px;
  background: #dbeefc;
  font-weight: 600;
  width: 100%;
  padding: 14px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
  margin-top: ${({ $marginTop }) => $marginTop}px;
  svg {
    margin-right: 10px;
    color: #4babee;
    min-width: 24px;
    font-size: 24px;
  }
`;
